import cronstrue from "cronstrue";
import { useEffect, useState } from "react";

import { Text, useFieldContext } from "@bps/fluent-ui";

interface ReadableCronDisplayProps {
  field: string;
}

export const ReadableCronDisplay: React.FC<ReadableCronDisplayProps> = ({
  field
}) => {
  const { value: cronText } = useFieldContext<string>(field);

  const [cronDescription, setCronDescription] = useState<string | undefined>();
  useEffect(() => {
    if (!cronText) return;

    try {
      setCronDescription(cronstrue.toString(cronText));
    } catch {
      setCronDescription(undefined);
    }
  }, [cronText]);

  if (!cronDescription) return null;

  return <Text variant="xSmall">{cronDescription}</Text>;
};
